import React from "react";
import * as BiIcons from "react-icons/bi";
import * as parametrosActions from "../../../../../../store/modules/personas/parametros_store/actions";
import * as controller from "../../../../../../controllers/personasController/parametrosController";
import { useSelector } from "react-redux";
import { notifySuccess } from "../../../../../../components/message/message";
import { PLATAFORMA_DISCADOR_ID } from "../../../../../../util/constants";

function TableParamatroTelecom({ integracao, isIntegracao = false }) {
  const { seeRegister, id_integracao } = useSelector(
    (state) => state.personasParametros
  );
  const { tipoLoja } = useSelector((state) => state.personasPapeis);
  const data = integracao;

  async function handleRemoveItem(parametro) {
    const isValid = await controller.deleteIntegracao(
        parametro,
        tipoLoja?.id,
        id_integracao
      );
    if (isValid) {
      notifySuccess("Integração excluída com sucesso!");
    }
  }

  async function handleGetItem(item) {
    parametrosActions.setItem(item);
  }
  return (
    <>
      <table style={{ marginTop: "20px", width: "95%", marginLeft: "2%" }}>
        <thead>
          <tr>
            <th>Integração</th>
            <th>URL</th>
            <th>Login</th>
            <th style={{ textAlign: "center" }}>Ações</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            return (
              <tr key={index}>
                <td>{row.plataforma ?? ""}</td>
                <td>
                  {row[
                    row.plataformaIntegracaoId?.toUpperCase() ===
                    PLATAFORMA_DISCADOR_ID
                      ? "telecom_urlDiscador"
                      : "telecom_url"
                  ] ?? ""}
                </td>
                <td>
                  {row[
                    row.plataformaIntegracaoId?.toUpperCase() ===
                    PLATAFORMA_DISCADOR_ID
                      ? "telecom_login"
                      : "telecom_usuarioApiAgente"
                  ] ?? ""}
                </td>
                <td style={{ textAlign: "center" }}>
                  <>
                    {!seeRegister && (
                      <BiIcons.BiEdit
                        style={{
                          fontSize: "1.2rem",
                          cursor: "pointer",
                          color: "#C4C7CA",
                        }}
                        onClick={() => {
                          handleGetItem(row);
                        }}
                      />
                    )}
                  </>
                  <>
                    {!seeRegister && (
                      <BiIcons.BiTrash
                        style={{
                          fontSize: "1.2rem",
                          cursor: "pointer",
                          color: "#C4C7CA",
                        }}
                        onClick={() => {
                          handleRemoveItem(row);
                        }}
                      />
                    )}
                  </>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}

export default TableParamatroTelecom;
